import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  PublishData,
  capitalize,
  getDataWithFilterUrl,
  separateDasFromUrl,
  updateFormSchemaWithRealtion,
} from "../../controllers/APIController";
import { Button, Image } from "@nextui-org/react";
import { useEffect, useState } from "react";
import logo from "../../Images/logo.svg";
import LoadingPage from "../../components/Loader/LoadingPage";
import {
  BooleanInput,
  DateInput,
  DropDownInput,
  FileInput,
  IntegerInput,
  PasswordInput,
  RelationDropDownInput,
  SliderInput,
  TextAreaInput,
  TextInput,
} from "../FormBuilder/InputField/InputField";
import { checkValidation } from "../../utils/checkValidation";
import { increasedMetricCurrentCount } from "../../utils/helper";

const getInitailState = (arr) => {
  const data = {};

  arr?.forEach((item) => {
    if (item[1].type === "boolean") {
      data[item[0]] = "false";
    }
    if (item[1].type === "slider") {
      data[item[0]] = item[1].value || 0;
    } else data[item[0]] = "";
  });
  return data;
};

const Survey = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [CollectionInfo, setCollectionInfo] = useState();
  const [formdata, setFormData] = useState({});
  const [formSchema, setformSchema] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [links, setLinks] = useState([]);

  const { _orgId } = useParams();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const personEmail = searchParams.get("username");

  let paramsList = pathname.split("/");

  let HeadingTitle = capitalize(separateDasFromUrl(paramsList[2]));
  let description = CollectionInfo?.attributes?.Description;

  const filteredUrl =
    "filters[Name][$eqi]=" + paramsList[3].replaceAll("-", " ");

  const changeHandler = async (title, value, type) => {

    if (type === "file") {
      let formData = new FormData();
      formData.append("files", value);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_STRAPI_IP_ADDRESS}/api/upload`,
          {
            method: "POST",
            body: formData,
          }
        );
        const data = await response.json();

        setFormData({
          ...formdata,
          [title]: { value: data[0].id, url: data[0].url },
        });
      } catch (error) {
        console.error("Upload error!", error);
      }
    } else if (type === "boolean") {
      if (value === "") {
        setFormData({ ...formdata, [title]: "false" });
      } else {
        setFormData({ ...formdata, [title]: value });
      }
    } else setFormData({ ...formdata, [title]: value });
  };



  const submitHandler = async () => {
    const isValid = checkValidation(formSchema, formdata, setValidationErrors);
    if (!isValid) {
      setErrorMessage("Something went wrong!!");
      return;
    }

    const publishData = {
      Metric_Id: CollectionInfo.attributes.Name,
      JsonSchema: { ...formdata, "Submitted By": personEmail },
      Organization: +_orgId,
    };

    let result = await PublishData({ data: publishData }, "responses");
    await increasedMetricCurrentCount(
      CollectionInfo?.id,
      result?.data?.attributes?.createdAt
    );

    navigate(`/${_orgId}/external-survey/thank-you`);
  };


  const clickHandler = (metricName, relatedTo) => {
    let metric = metricName.replaceAll(" ", "-");
    let relatedToName = relatedTo.replaceAll(" ", "-");
    navigate(`/${_orgId}/${metric}/${relatedToName}/create`);

    window.location.reload();
  };

  useEffect(() => {
    getDataWithFilterUrl("metrics", filteredUrl)
      .then((data) => {
        const responseData = data.data[0]?.attributes?.JsonSchema?.properties;
        let responseArr = Object.keys(responseData).map((key) => [
          key,
          responseData[key],
        ]);
        responseArr.sort((a, b) => {
          return a[1].id - b[1].id;
        });
        setCollectionInfo(data.data[0]);
        setformSchema(responseArr);
        setLinks(data.data[0].attributes?.Links?.Links);
        setFormData(getInitailState(responseArr));
        setIsLoading(false);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, []);


  return (
    <>
      <div className="min-h-screen bg-neutral-50">
        {/* Header */}
        <div className="bg-white border-b border-neutral-200 px-8 py-6 shadow-sm">
          <div className="flex items-center justify-center">
            <Image width={80} alt="NextUI hero Image" src={logo} />
          </div>
        </div>

        <LoadingPage isLoading={isLoading} loadingText="Loading survey data...">
          <div className="max-w-4xl mx-auto p-6">
            <div className="mb-6">
              <h1 className="text-2xl font-bold text-gray-900">Survey</h1>
              <p className="text-gray-600 mt-2">View and manage survey responses</p>
            </div>
            {/* Survey Card */}
            <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-8">
              <div className="text-center mb-8">
                <h1 className="text-2xl font-semibold text-neutral-900 mb-4">{HeadingTitle}</h1>
                <p className="text-neutral-600 leading-relaxed">{description}</p>
              </div>
              
              <div className="space-y-6">
              {formSchema &&
                formSchema.map((row, index) => {
                  const uniqueId = Date.now().toString + index;
                  if (row[1].type === "string" || row[1].type === "text") {
                    return (
                      <TextInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "password") {
                    return (
                      <PasswordInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "integer") {
                    return (
                      <IntegerInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "dropdown") {
                    return (
                      <DropDownInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "slider") {
                    return (
                      <SliderInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "boolean") {
                    return (
                      <BooleanInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "textarea") {
                    return (
                      <TextAreaInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "date") {
                    return (
                      <DateInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "file") {
                    return (
                      <FileInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        inputfiledId={uniqueId}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                      />
                    );
                  }
                  if (row[1].type === "relation") {
                    updateFormSchemaWithRealtion(
                      formSchema,
                      index,
                      setformSchema
                    );
                    return (
                      <RelationDropDownInput
                        data={row[1]}
                        value={formdata[row[0]]}
                        validationErrors={validationErrors}
                        onChangeHandler={changeHandler}
                        onClickHandler={clickHandler}
                      />
                    );
                  }
                  return null;
                })}
              
              <div className="flex justify-center pt-8 border-t border-neutral-200">
                <Button
                  color="primary"
                  size="sm"
                  className="bg-primary-600 hover:bg-primary-700 text-white px-12 font-medium"
                  onClick={submitHandler}
                >
                  Submit
                </Button>
              </div>
              </div>
            </div>
          </div>
        </LoadingPage>
      </div>
    </>
  );
};

export default Survey;
